import { useEffect, useState } from "react";
import { getFeatures } from "../redux/api/featuresAPI";

// Mirrors the enabled/disabled check every AdvancedSettings "Features" toggle
// needs at its consumption point (see Cameras.jsx's grid_view check) without
// duplicating the fetch-and-find in every component.
export default function useFeatureFlag(featureId, defaultEnabled = true) {
    const [enabled, setEnabled] = useState(defaultEnabled);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        const fetchFeature = async () => {
            try {
                const { data } = await getFeatures();
                const feature = data?.find((f) => f.id === featureId);
                if (mounted && feature) {
                    setEnabled(feature.enabled);
                }
            } catch (error) {
                console.error("Failed to load features.", error);
            } finally {
                if (mounted) setLoading(false);
            }
        };
        fetchFeature();
        return () => {
            mounted = false;
        };
    }, [featureId]);

    return { enabled, loading };
}
